import { getIconProps, type IconProps } from '#types'

interface ArrowIconProps extends IconProps {
  strokeWidth?: number
}

/**
 * Arrow pointing right — horizontal stem with arrowhead.
 *
 * Use Tailwind rotation classes for other directions:
 * - Left (back): `rotate-180`
 * - Down: `rotate-90`
 * - Up: `-rotate-90`
 * - Diagonal: `rotate-[45deg]`, `rotate-[-45deg]`, etc.
 *
 * @example
 * ```tsx
 * <button>
 *   Next <ArrowIcon className="h-4 w-4" />
 * </button>
 * <button>
 *   Back <ArrowIcon className="h-4 w-4 rotate-180" />
 * </button>
 * ```
 */
export function ArrowIcon({ strokeWidth = 1.5, ...props }: ArrowIconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 16 16">
      <path
        d="M3.33398 8H12.6673"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 8L8.66732 12"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 8L8.66732 4"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
